import React, { useState, useEffect } from "react";
import { Box, Modal, Grid, Button, Snackbar, Alert, IconButton, TablePagination } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { ValidatorForm } from "react-material-ui-form-validator";
import ValidatedDatePicker from "../ui/DatePicker";
import moment from "moment";
import VisibilityIcon from "@mui/icons-material/Visibility";
import RefreshIcon from "@mui/icons-material/Refresh";
import axios from "../../axios-order";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    maxHeight: "90vh",
    boxShadow: 24,
    background: "#fff",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
};

const ErpConnectorModel = ({
    opeErpConnector,
    closeErpConnector,
    nameOfTheModel,
    ErpTableHeader,
    ErpTableColumn,
    importToCWS,
    exportToExcel,
    logApitName,
    connecotrName,
    erpDataExportLoading,
    importToCwsLoading,
}) => {
    const [submitLoader, setSubmitLoader] = useState(false);
    const [refreshLoader, setRefreshLoader] = useState(false);
    const [tableLoader, setTableLoader] = useState(false);
    const [erpData, setErpData] = useState([]);
    const [logRecords, setLogRecords] = useState([]);
    const [showSecondTable, setShowSecondTable] = useState(false);
    const [formValues, setFormValues] = useState({
        fromDate: null,
        toDate: null,
    });
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "info",
    });

    // Pagination state for logRecords table (first table) - server-side
    const [logPage, setLogPage] = useState(0);
    const [logRowsPerPage, setLogRowsPerPage] = useState(25);
    const [logTotalElements, setLogTotalElements] = useState(0);

    const handleLogChangePage = (event, newPage) => {
        setLogPage(newPage);
        getLogs(newPage, logRowsPerPage);
    };

    const handleLogChangeRowsPerPage = (event) => {
        const newSize = parseInt(event.target.value, 10);
        setLogRowsPerPage(newSize);
        setLogPage(0);
        getLogs(0, newSize);
    };

    const handleCloseSnackbar = () => {
        setSnackbar({ open: false, message: "", severity: "info" });
    };

    const handleBack = () => {
        setShowSecondTable(false);
    };

    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    const handleButton = async (transId) => {
        localStorage.setItem("transaction_id", transId);
        setTableLoader(true);
        const payLoadData = {
            business_entity_id: localStorage.getItem("business_entity_id"),
            api_point_name: logApitName,
            is_import: false,
            record_id: transId
        };

        try {
            const [apiResponse] = await Promise.all([
                axios.post(`/arc/get_erp_connector_data`, payLoadData),
                delay(1000),
            ]);

            if (apiResponse?.data?.status === true) {
                console.log("res?.data?.data.........", apiResponse?.data?.data);
                setErpData(apiResponse?.data?.data || []);
                setShowSecondTable(true);
            } else {
                setSnackbar({
                    open: true,
                    message: apiResponse?.data?.message || "No records found",
                    severity: "error",
                });
                setErpData([]);
            }
        } catch (err) {
            console.error(err);
            setSnackbar({
                open: true,
                message: err?.response?.data?.message || "Error fetching ERP data",
                severity: "error",
            });
        } finally {
            setTableLoader(false);
        }
    };

    const getLogs = async (pageParam = 0, sizeParam = logRowsPerPage) => {
        setRefreshLoader(true);
        setFormValues({ fromDate: null, toDate: null });
        const entityId = localStorage.getItem("business_entity_id");
        console.log(entityId);
        console.log(logApitName);

        const payLoadData = {
            business_entity_id: entityId,
            record_type: logApitName,
            size: sizeParam,
            page: pageParam,
        };

        try {
            const [apiResponse] = await Promise.all([
                axios.post(`/get_erp_connector_log`, payLoadData),
                delay(1000),
            ]);

            if (apiResponse?.data?.status) {
                console.log("res?.data?._embedded.........", apiResponse?.data?._embedded);
                setLogRecords(apiResponse?.data?._embedded || []);
                setLogTotalElements(apiResponse?.data?.totalElements || 0);
                setLogPage(pageParam);
            } else {
                setLogRecords([]);
                setLogTotalElements(0);
                setSnackbar({
                    open: true,
                    message: "No data found",
                    severity: "error",
                });
            }
        } catch (err) {
            console.error(err);
            setSnackbar({
                open: true,
                message: err?.response?.data?.message || "Error fetching data",
                severity: "error",
            });
        } finally {
            setRefreshLoader(false);
        }
    };

    const onSubmitHandler = async () => {
        setSubmitLoader(true);
        const payLoadData = {
            entityId: localStorage.getItem("business_entity_id") ? parseInt(localStorage.getItem("business_entity_id")) : null,
            templateName: logApitName,
            startDate: formValues.fromDate ? moment(formValues.fromDate).format('DD-MM-YYYY') : null,
            endDate: formValues.toDate ? moment(formValues.toDate).format('DD-MM-YYYY') : null,
            erpName: "Business Center",
        };

        try {
            const [apiResponse] = await Promise.all([
                axios.post("/arc/manual_invoke_erp_data", payLoadData),
                delay(1000),
            ]);
            await getLogs(0, logRowsPerPage);
        } catch (err) {
            console.error(err);
            setSnackbar({
                open: true,
                message: err?.response?.data?.message || "Error invoking ERP data",
                severity: "error",
            });
        } finally {
            setSubmitLoader(false);
        }
    };

    const inputHandlerFromDatePicker = (v) => {
        if (v && v !== "Invalid Date" && moment(v, 'DD-MM-YYYY', true).isValid()) {
            setFormValues((prev) => ({ ...prev, fromDate: new Date(v) }));
        }
    };

    const inputHandlerToDatePicker = (v) => {
        if (v && v !== "Invalid Date" && moment(v, 'DD-MM-YYYY', true).isValid()) {
            setFormValues((prev) => ({ ...prev, toDate: new Date(v) }));
        }
    };

    useEffect(() => {
        if (opeErpConnector) {
            getLogs(0, logRowsPerPage);
        }
    }, [opeErpConnector]);

    // Renders only the table rows (this part scrolls)
    const renderTableContent = () => {
        switch (showSecondTable) {
            case false:
                return (
                    <table className="custome-table">
                        <thead>
                            <tr>
                                <th>From Date</th>
                                <th>To Date</th>
                                <th>LAST FETCH DATE</th>
                                <th>Status</th>
                                <th>Sync Type</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tableLoader ? (
                                <tr>
                                    <td style={{ fontWeight: 'bold' }} colSpan={5}>
                                        Loading..Please Wait!
                                    </td>
                                </tr>
                            ) : (
                                <>
                                    {logRecords?.map((v) => (
                                        <tr key={v.id}>
                                            <td>
                                                {v.fromDate
                                                    ? moment(v.fromDate).format('DD-MM-YYYY')
                                                    : 'N/A'}
                                            </td>
                                            <td>
                                                {v.toDate
                                                    ? moment(v.toDate).format('DD-MM-YYYY')
                                                    : 'N/A'}
                                            </td>
                                            <td>{v.lastFetchDate}</td>
                                            <td>{v.status}</td>
                                            <td>{v.syncType}</td>
                                            <td style={{ cursor: 'pointer' }}>
                                                {v.status === 'Success' || v.status === 'Pass' ? (
                                                    <VisibilityIcon
                                                        className="action-icon-button showIcon"
                                                        onClick={() => handleButton(v.transId)}
                                                    />
                                                ) : v.status === 'Fail' ? (
                                                    <VisibilityIcon
                                                        style={{ color: 'red' }}
                                                        onClick={() => handleButton(v.transId)}
                                                    />
                                                ) : (
                                                    <VisibilityIcon color="disabled" />
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                    {logRecords.length === 0 && (
                                        <tr>
                                            <td style={{ color: 'red', fontWeight: 'bold' }} colSpan={5}>
                                                No Record Found!!
                                            </td>
                                        </tr>
                                    )}
                                </>
                            )}
                        </tbody>
                    </table>
                );
            case true:
                // Customer table (effitracHeader / effitracCol) shown after clicking the eye icon.
                // No pagination here — all rows are rendered directly.
                return (
                    <table className="custome-table">
                        <thead>
                            <tr>
                                {ErpTableHeader.map((value, index) => (
                                    <th key={index}>{value.label.toUpperCase()}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {erpData && erpData.length > 0 ? (
                                erpData.map((row, rowIndex) => (
                                    <tr key={rowIndex}>
                                        {ErpTableColumn.map((col, colIndex) => (
                                            <td key={colIndex}>
                                                {col.render ? col.render(rowIndex, row) : row[col.key] || 'N/A'}
                                            </td>
                                        ))}
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={6}>No data available</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                );
            default:
                return null;
        }
    };

    // Renders the pagination bar. Only the first (log) table has pagination now.
    const renderPagination = () => {
        if (showSecondTable) {
            // No pagination for the ERP customer data table.
            return null;
        } else {
            if (tableLoader || !logRecords || logRecords.length === 0) return null;
            return (
                <TablePagination
                    rowsPerPageOptions={[25, 50, 100]}
                    component="div"
                    count={logTotalElements}
                    rowsPerPage={logRowsPerPage}
                    page={logPage}
                    onPageChange={handleLogChangePage}
                    onRowsPerPageChange={handleLogChangeRowsPerPage}
                />
            );
        }
    };

    return (
        <Modal
            keepMounted
            open={opeErpConnector}
            onClose={closeErpConnector}
            aria-labelledby="keep-mounted-modal-title"
            aria-describedby="keep-mounted-modal-description"
        >
            <Box sx={style}>
                <div
                    style={{
                        color: "#fff",
                        background: "var(--app-bar-bg)",
                        padding: "7px 15px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        flexShrink: 0,
                    }}
                >
                    <h4 style={{ fontFamily: "Dosis", marginBottom: "0px" }}>
                        {nameOfTheModel}
                    </h4>
                    {showSecondTable && erpData && erpData.length >= 1 && (
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                gap: "10px",
                            }}
                        >
                            <div>
                                <button
                                    className="button-primary"
                                    style={{ marginLeft: "0px", marginBottom: "2%" }}
                                    onClick={handleBack}
                                >
                                    BACK
                                </button>
                            </div>
                            <div>
                                <button
                                    className="button-primary"
                                    onClick={() => importToCWS(erpData, connecotrName, localStorage.getItem("transaction_id"))}
                                    style={{
                                        position: "relative",
                                        display: "inline-flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                    disabled={importToCwsLoading}
                                >
                                    {importToCwsLoading ? (
                                        <CircularProgress
                                            size={18}
                                            sx={{ color: "#fff" }}
                                        />
                                    ) : (
                                        "Import To CWS"
                                    )}
                                </button>
                            </div>
                            <div>
                                <button
                                    className="button-primary"
                                    onClick={() => exportToExcel(logApitName, localStorage.getItem("transaction_id"))}
                                    style={{
                                        position: "relative",
                                        display: "inline-flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                    disabled={erpDataExportLoading}
                                >
                                    {erpDataExportLoading ? (
                                        <CircularProgress
                                            size={18}
                                            sx={{ color: "#fff" }}
                                        />
                                    ) : (
                                        "Export To Excel"
                                    )}
                                </button>
                            </div>
                        </div>
                    )}
                </div>

                <div
                    className="modal-body"
                    style={{
                        padding: "20px",
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        minHeight: 0,
                    }}
                >
                    {!showSecondTable && (
                        <>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    margin: "10px 0px",
                                    borderBottom: "2px solid #ddd",
                                    fontFamily: "Dosis",
                                    flexShrink: 0,
                                }}
                            >
                                <h5>Filter</h5>
                                <IconButton onClick={() => getLogs(0, logRowsPerPage)} disabled={refreshLoader} title="Refresh Logs">
                                    {refreshLoader ? (
                                        <CircularProgress size={24} sx={{ color: "#1976d2" }} />
                                    ) : (
                                        <RefreshIcon />
                                    )}
                                </IconButton>
                            </div>
                            <div style={{ flexShrink: 0 }}>
                                <ValidatorForm
                                    useRef="form"
                                    onSubmit={onSubmitHandler}
                                    onError={(errors) => console.log(errors)}
                                >
                                    <Grid container spacing={3}>
                                        <Grid item xs={5}>
                                            <div style={{ minWidth: "200px" }}>
                                                <label style={{ margin: 0, fontWeight: 500, fontFamily: "Dosis", }}>
                                                    From Date
                                                    <span style={{ color: "red" }}>*</span>:
                                                </label>
                                                <ValidatedDatePicker
                                                    placeholder="From Date"
                                                    errorMessages={["This field is required"]}
                                                    validators={["required"]}
                                                    value={formValues.fromDate ?? ""}
                                                    onChange={inputHandlerFromDatePicker}
                                                    style={{ width: "150px", marginTop: "8px" }}
                                                />
                                            </div>
                                        </Grid>
                                        <Grid item xs={5}>
                                            <div style={{ minWidth: "200px" }}>
                                                <label style={{ margin: 0, fontWeight: 500, fontFamily: "Dosis", }}>
                                                    To Date
                                                    <span style={{ color: "red" }}>*</span>:
                                                </label>
                                                <ValidatedDatePicker
                                                    minDateForDatepicker={formValues.fromDate ?? ""}
                                                    placeholder="To Date"
                                                    errorMessages={["This field is required"]}
                                                    validators={["required"]}
                                                    value={formValues.toDate ?? ""}
                                                    onChange={inputHandlerToDatePicker}
                                                    style={{ width: "150px", marginTop: "8px" }}
                                                />
                                            </div>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                type="submit"
                                                disabled={submitLoader}
                                                sx={{
                                                    height: "36px",
                                                    mt: "24px",
                                                    px: "16px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    fontFamily: "Dosis",
                                                    minWidth: "100px",
                                                }}
                                            >
                                                {submitLoader ? (
                                                    <CircularProgress
                                                        size={24}
                                                        sx={{ color: "#fff" }}
                                                    />
                                                ) : (
                                                    "SUBMIT"
                                                )}
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </ValidatorForm>
                            </div>
                        </>
                    )}

                    {tableLoader ? (
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                padding: "20px",
                            }}
                        >
                            <CircularProgress size={40} sx={{ color: "#1976d2" }} />
                        </div>
                    ) : (
                        <>
                            {/* Scrollable table area only */}
                            <div
                                className="responsive-table"
                                style={{
                                    marginTop: '20px',
                                    flex: 1,
                                    overflowY: 'auto',
                                    minHeight: 0,
                                }}
                            >
                                {renderTableContent()}
                            </div>

                            {/* Fixed/static pagination bar, always visible, doesn't scroll.
                                Only rendered for the first (log) table now. */}
                            <div
                                style={{
                                    flexShrink: 0,
                                    borderTop: '1px solid #e0e0e0',
                                    background: '#fff',
                                }}
                            >
                                {renderPagination()}
                            </div>
                        </>
                    )}
                </div>
                <div className="modal-footer" style={{ flexShrink: 0 }}>
                    <button
                        type="button"
                        className="button-outlined-secondary"
                        onClick={closeErpConnector}
                    >
                        Close
                    </button>
                </div>
                <Snackbar
                    open={snackbar.open}
                    autoHideDuration={2000}
                    onClose={handleCloseSnackbar}
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                >
                    <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
                        {snackbar.message}
                    </Alert>
                </Snackbar>
            </Box>
        </Modal>
    );
};

export default ErpConnectorModel;